import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", href: "#home" },
  { label: "About Sikaiadah", href: "#about" },
  { label: "Platform", href: "#platform" },
  { label: "Ward 3 & Communities", href: "#ward-3" },
  { label: "Supporters", href: "#supporters" },
  { label: "Latest", href: "#latest" },
  { label: "Get Involved", href: "#get-involved" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#1B0640]/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 flex items-center justify-between h-32 sm:h-40 lg:h-48">
        <a href="#home" data-testid="nav-logo" className="flex items-center gap-2 shrink-0">
          <img
            src="/assets/logo.png"
            alt="Together We Grow Ward 3"
            className="h-28 sm:h-36 lg:h-44 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8 xl:gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[13px] tracking-[0.18em] uppercase text-classy-soft hover:text-classy transition-colors duration-200 font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://www.zeffy.com/en-US/donation-form/community-is-our-power"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-donate-btn"
            className="hidden sm:inline-flex btn-classy px-6 py-2.5 rounded-full text-[12px] uppercase"
          >
            Donate
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-classy p-2"
            aria-label="Open menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-[#1B0640]/95 backdrop-blur-xl border-t border-white/10"
        >
          <div className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm tracking-[0.16em] uppercase text-classy-soft hover:text-classy"
              >
                {l.label}
              </a>
            ))}
            <a
              href="https://www.zeffy.com/en-US/donation-form/community-is-our-power"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-donate-btn"
              className="btn-classy mt-2 px-6 py-3 rounded-full text-[12px] uppercase text-center"
            >
              Donate
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
